export interface KnowledgeBaseConfig {
    maxLength: number;
}

export const knowledgeBaseConfig: KnowledgeBaseConfig = {
    maxLength: 100 // default value
};
